<template>
  <div v-if="selectedCompany">
    <!-- Add Contract Button -->
    <div class="mb-4">
      <button class="button is-primary" @click="handleAddContract">
        Add New Contract
      </button>
    </div>

    <!-- Contracts Table -->
    <div class="table-container">
      <table class="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Amount</th>
            <th>Start</th>
            <th>End</th>
            <th>
              <span class="icon"><i class="fas fa-users"></i></span>
            </th>
            <th>
              <span class="icon"><i class="fas fa-camera"></i></span>
            </th>
            <th>
              <span class="icon"><i class="fas fa-building"></i></span>
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="contracts.length > 0">
          <tr v-for="(contract, i) in contracts" :key="i">
            <td>
              <a
                class="entity-link"
                href="#"
                @click.prevent="handleEditContract(contract)"
                ><span class="has-text-grey">#</span>{{ contract.id }}
                <span class="icon is-small edit-icon">
                  <i class="fas fa-edit"></i>
                </span>
              </a>
            </td>
            <td class="has-text-right" v-if="contract.amount">
              {{ contract.amount }} {{ contract.currency }}
            </td>
            <td v-else class="has-text-centered">
              <span class="tag is-warning">Trial</span>
            </td>
            <td>
              {{ formatDate(contract.start_date, { showRelative: false }) }}
            </td>
            <td>
              {{
                formatDate(contract.end_date?.Time || "-", {
                  showRelative: false,
                })
              }}
            </td>
            <td class="has-text-centered">
              {{ contract.features.user_count }}
            </td>
            <td class="has-text-centered">
              {{ contract.features.camera_count }}
            </td>
            <td class="has-text-centered">
              {{ contract.features.project_count }}
            </td>
            <td>
              <button
                class="button is-info"
                @click="handleAddInvoice(contract)"
              >
                <span class="icon">
                  <i class="fas fa-file-invoice"></i>
                </span>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { httpInstance as http } from "@/plugins/http";
import { formatDate } from "@/utils/date_converter";
import toast from "@/utils/toast";

export default {
  name: "CompanyContractsTab",
  props: {
    companyData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      contracts: [],
    };
  },
  computed: {
    ...mapState(["selectedCompany"]),
    company() {
      return this.companyData || this.selectedCompany;
    },
  },
  methods: {
    formatDate,
    getContracts() {
      if (!this.company || !this.company.id) return;
      http
        .get(`contracts?page=1&size=20&company_id=${this.company.id}`)
        .then((response) => {
          this.contracts = response.data.data;
        });
    },
    save(contract) {
      var formData = new FormData();
      formData.append("id", contract.id);
      formData.append("start_date", contract.start_date);
      if (contract.end_date.Valid) {
        formData.append("end_date", contract.end_date.Time);
      }

      if (contract.next_invoice_date.Valid) {
        formData.append("next_invoice_date", contract.next_invoice_date.Time);
      }

      formData.append("user_count", contract.features.user_count);
      formData.append("project_count", contract.features.project_count);
      formData.append("camera_count", contract.features.camera_count);

      http.patch("contracts/", formData).then((response) => {
        if (response.status !== 200) {
          toast.error("Error occurred");
          return;
        }
        toast.success("Updated");
      });

      setTimeout(() => {
        this.getContracts();
      }, 1000);
    },
    handleAddContract() {
      this.$emit("show-contract-modal");
    },
    handleEditContract(contract) {
      this.$emit("show-edit-contract-modal", contract);
    },
    handleAddInvoice(contract) {
      this.$emit("show-invoice-modal", contract.id);
    },
  },
  mounted() {
    if (this.company) {
      this.getContracts();
    }

    // Listen for contract events to refresh contracts list
    this.$root.$on("contract-created", this.getContracts);
    this.$root.$on("contract-updated", this.getContracts);
  },
  beforeDestroy() {
    // Clean up event listeners
    this.$root.$off("contract-created", this.getContracts);
    this.$root.$off("contract-updated", this.getContracts);
  },
};
</script>

<style></style>
